import { gql } from "@apollo/client";
import { documentTransition, stateTransition } from "features/insuranceDocument/queries/fragments";

export const AVAILABLE_DOCUMENT_TRANSITIONS = gql`
  query availableDocumentTransitions {
    availableDocumentTransitions {
      ...documentTransition
    }
  }
  ${documentTransition}
`;

export const DOCUMENT_STATE_TRANSITIONS = gql`
  query documentStateTransitions($documentAttachmentId: Int!) {
    documentStateTransitions(documentAttachmentId: $documentAttachmentId) {
      ...stateTransition
    }
  }
  ${stateTransition}
`;
